var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9997 19.7044V30.0747M27.9997 36.2969H28.0204M46.6663 28.0007C46.6663 38.31 38.309 46.6673 27.9997 46.6673C17.6904 46.6673 9.33301 38.31 9.33301 28.0007C9.33301 17.6913 17.6904 9.33398 27.9997 9.33398C38.309 9.33398 46.6663 17.6913 46.6663 28.0007Z",
    stroke: "#FFE071",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })));
};
export default SvgWarningIcon;